const u = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=800&q=80`;

export const SERVICE_IMGS = {
  "custom-software": u("photo-1498050108023-c5249f4df085"),
  "web-development": u("photo-1547658719-da2b51169166"),
  "mobile-apps": u("photo-1551650975-87deedd944c3"),
  "ui-ux": u("photo-1559028012-481c04fa702d"),
  "ai-automation": u("photo-1620712943543-bcc4688e7485"),
  "cloud": u("photo-1558494949-ef010cbdcc31"),
  "api": u("photo-1518770660439-4636190af475"),
  "erp-crm": u("photo-1551288049-bebda4e38f71"),
  "ecommerce": u("photo-1472851294608-062f824d29cc"),
  "digital-transformation": u("photo-1451187580459-43490279c0fa"),
};

export const INDUSTRY_IMGS = {
  Healthcare: u("photo-1576091160399-112ba8d25d1d"),
  Education: u("photo-1503676260728-1c00da094a0b"),
  Finance: u("photo-1611974789855-9c2a0a7236a3"),
  Retail: u("photo-1441986300917-64674bd600d8"),
  Manufacturing: u("photo-1565043666747-69f6646db940"),
  "Real Estate": u("photo-1560518883-ce09059eeffa"),
  Startups: u("photo-1559136555-9303baea8ebd"),
  Logistics: u("photo-1586528116311-ad8dd3c8310d"),
  Government: u("photo-1486406146926-c627a92ad1ab"),
  Travel: u("photo-1488646953014-85cb44e25828"),
  Hospitality: u("photo-1566073771259-6a8506099945"),
  Telecom: u("photo-1544197150-b99a580bb7a8"),
  "Media & Entertainment": u("photo-1485846234645-a62644f84728"),
  Energy: u("photo-1509391366360-2e959784a276"),
  Insurance: u("photo-1450101499163-c8848c66ca85"),
  Agriculture: u("photo-1500382017468-9049fed747ef"),
};

export const WHY_IMGS = [
  u("photo-1522071820081-009f0129c71c"),
  u("photo-1517180102446-f3ece451e9d8"),
  u("photo-1461749280684-dccba630e2f6"),
  u("photo-1552664730-d307ca884978"),
  u("photo-1600880292203-757bb62b4baf"),
  u("photo-1581091226825-a6a2a5aee158"),
  u("photo-1542744094-24638eff58bb"),
  u("photo-1519389950473-47ba0277781c"),
  u("photo-1550751827-4bd374c3f58b"),
  u("photo-1460925895917-afdab827c52f"),
  u("photo-1434030216411-0b793f4b4173"),
  u("photo-1486312338219-ce68d2c6f44d"),
  u("photo-1526628953301-3e589a6a8b74"),
  u("photo-1521791136064-7986c2920216"),
];

export const PROCESS_IMGS = [
  u("photo-1454165804606-c3d57bc86b40"),
  u("photo-1517245386807-bb43f82c33c4"),
  u("photo-1561070791-2526d30994b5"),
  u("photo-1555066931-4365d14bab8c"),
  u("photo-1531482615713-2afd69097998"),
  u("photo-1526374965328-7f61d4dc18c5"),
  u("photo-1581092160562-40aa08e78837"),
];
